<template>
	<CLoader :pConfigLoad="ConfigLoad">
        <template slot="BodyFormLoad">
			<div class="container-fluid">
				<form id="FormPedidoFisico" role="form" method="post" autocomplete="off" onSubmit="return false">
					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
							<label class="form-label" for="TipoDictamen">Estatus</label>
							<select v-model="ObjDictamen.TipoDictamen" class="form-control form-select" id="TipoDictamen">
								<option value="0">Seleccione una opción</option>
								<option value="1">Autorizada</option>
								<option value="2">Rechazada</option>
							</select>
							<CValidation v-if="this.errorvalidacion.TipoDictamen" :Mensaje="'*'+errorvalidacion.TipoDictamen[0]"/>
						</div>
					</div>
					
					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
							<label class="form-label" for="Dictamen">Dictamen:</label>
							<textarea v-model="ObjDictamen.Dictamen" class="form-control" id="Dictamen" placeholder="Ingresar Dictamen" rows="3"></textarea>
							<CValidation v-if="this.errorvalidacion.Dictamen" :Mensaje="'*'+errorvalidacion.Dictamen[0]"/>
						</div>
					</div>
											
					<br>
				
				</form>
			</div>
		</template>
	</CLoader>
</template>

<script>
import BuscadorCliente from '@/components/BuscadorCliente.vue';
import Calendar from '@/helpers/StaticComboBox.js';
import moment from 'moment';

export default {
    name: 'FormPedidoFisico',
    props: ['poBtnSave'],
    components:{
		BuscadorCliente
    },
    data() {
        return {
			ConfigLoad:{
                ShowLoader: true,
                ClassLoad: false,
            },
            ObjDictamen: {
				IdGarantia: 0,
				Dictamen: '',
				TipoDictamen: 0
            },
            errorvalidacion: [],
			Emit: this.poBtnSave.EmitSeccion,
        }
    },
    methods :
    {
       	async Guardar()
        {

			let formData = new FormData();
			formData.set('IdGarantia', this.ObjDictamen.IdGarantia);
			formData.set('TipoDictamen', this.ObjDictamen.TipoDictamen);
			formData.set('Dictamen', this.ObjDictamen.Dictamen);
		
			
			this.errorvalidacion = [];
            this.poBtnSave.Toast = 0; 
            this.poBtnSave.DisableBtn = true;
			
			await this.$http.post('garantiasdictamen', formData,{
				headers: {
					'Content-Type': 'multipart/form-data'
				}
			}).then((res)=>{
				this.EjecutaConExito(res);
			}).catch(err=>{   
				this.EjecutaConError(err);
			});
        },
		EjecutaConExito(res)
        {
            this.poBtnSave.DisableBtn = false;  
            this.poBtnSave.Toast = 1;
            this.bus.$emit('CloseModal_'+this.Emit);
            this.bus.$emit('List_seccionGarantia');
        },
        EjecutaConError(err)
        {
            this.poBtnSave.DisableBtn = false;
            
            if(err.response.data.errors){
                this.errorvalidacion = err.response.data.errors;
                this.poBtnSave.Toast = 2;
            }
            else{
                this.$toast.error(err.response.data.message);
            }
        },
		Recuperar()
        {
            this.$http.get(
                "pedidosFisicos/"+this.objPedidoFisico.IdPedidoFisico
            ).then((res) => {
                this.objPedidoFisico = res.data.data;
				this.objCliente  = this.objPedidoFisico.cliente;
				//this.setCliente(this.objCliente);

				// en caso de que necesite fecha
				let formatedDate1 = this.objPedidoFisico.Fecha.replace(/-/g,'\/');
                this.objPedidoFisico.Fecha = new Date(formatedDate1);
            }).finally(()=>{
                this.ConfigLoad.ShowLoader = false;
            });
        },
        Limpiar()
        {
            this.ObjDictamen = {
				IdGarantia: 0,
				Dictamen: '',
				TipoDictamen: 0,
            };
				
            this.errorvalidacion = [];
        },
    },
    created() {
		this.poBtnSave.Toast = 0;

        this.bus.$off('Recovery_'+this.Emit);
        this.bus.$on('Recovery_'+this.Emit,(obj)=>
        {
            this.ConfigLoad.ShowLoader = true;    
            this.poBtnSave.DisableBtn = false;

            this.bus.$off('Save_'+this.Emit);
            this.bus.$on('Save_'+this.Emit,()=>
            {
                this.Guardar();
            });
            this.Limpiar();

			this.ObjDictamen = obj;
                
			this.ConfigLoad.ShowLoader = false;
            
        });
    }
}
</script>
